/**
 * Trust Strip Section
 *
 * Compact credibility section displayed directly under the hero CTA.
 * Replaces testimonials/social proof until real user numbers exist.
 * Each bullet addresses a specific user anxiety:
 * - "Will I accidentally send something wrong?" → pre-send reminder
 * - "Am I locked in?" → edit/cancel anytime
 * - "Will this annoy my contacts?" → contacts don't need an account
 * - "Is my data safe?" → privacy-first
 */

import { Group, SimpleGrid, Text, ThemeIcon } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { brandColors, semanticColors } from '../../config/theme';
import { landingContent } from '../../content/landingContent';

/**
 * Renders the trust strip — a row of check-mark bullets below the hero CTA.
 * Stacks vertically on mobile for readability.
 */
export const TrustStripSection = () => {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="md">
      {landingContent.trust.map((item) => (
        <Group key={item} gap="xs" wrap="nowrap">
          <ThemeIcon color={brandColors.primary} size={20} radius="xl" variant="light">
            <IconCheck size={14} />
          </ThemeIcon>
          <Text size="sm" c={semanticColors.text.body}>{item}</Text>
        </Group>
      ))}
    </SimpleGrid>
  );
};
